module.exports = `  <transition name="slideup">
    <div
      class="dialog-bottom dialog-item"
      id="dialog-market"
      v-if="dataisload &amp;&amp; isopen"
      :class="{ active: isopen }"
    >
      <div
        class="close-dialog dialog-mask mask"
        @click.prevent="closeSelf"
        data-target="#dialog-market"
      ></div>
      <div class="addon-dialog">
        <div class="addon-dialog-content">
          <a class="icon-remove-x" @click.prevent="closeSelf"></a>
          <div class="addon-item-detail">
            <new-image
              v-if="selected.Images.length !== 0"
              :url="selected.Images[0].Url"
              :size="'_w121_h128'"
              :name="alldatas.Name"
            ></new-image>
            <div class="addon-item-info">
              <h3 class="item-name">{{ alldatas.Name }}</h3>
              <div class="item-price">
                <span class="sell-price">$ {{alldatas.EventPrice >0 && alldatas.EventPrice < alldatas.SellPrice ?alldatas.EventPrice.toLocaleString(): alldatas.SellPrice.toLocaleString()}}</span
                ><span
                  class="origin-price"
                  v-if="alldatas.SellPrice !== alldatas.OriginPrice || alldatas.EventPrice &gt;0"
                  >{{ alldatas.OriginPrice.toLocaleString() }}</span
                >
              </div>
              <div
                class="h6 py-2"
                v-for="event in alldatas.Events"
                :key="event.ID"
              >
                <p>(活動) {{ event.Name }}</p>
              </div>
              <a class="addon-dialog-btn" @click.prevent="showProductInfo"
                >商品資訊</a
              >
              <div class="mt-2">Color: {{ selected.Name }}</div>
              <div class="addon-select-block">
                <ul class="addon-product-color">
                  <li
                    class="item-color"
                    @click="changeImg(color.ID)"
                    v-for="color in alldatas.Colors"
                    :key="color.ID"
                    :class="{ active: color.ID === selected.ID }"
                  >
                    <img
                      class="img-fluid"
                      :src="color.PintSizePictureUrl + '?w=20&amp;h=20'"
                    />
                  </li>
                </ul>
                <ul class="addon-size-wrap">
                  <li
                    @click="selectSpec(spec)"
                    v-for="spec in selected.Specs"
                    :key="spec.ID"
                    :class="{
                      weak: spec.Stock === 0,
                      selected: spec.ID === selectedSpecID,
                      preshow: alldatas.IsPreShow,
                    }"
                  >
                    <span>{{ spec.Name }} {{ spec.Description }}</span>
                  </li>
                </ul>
                <div class="addon-select-pc">
                  <div class="UiQuantity">
                    <a
                      class="UiQuantity__btn btn-minus"
                      @click.prevent="reduceCount"
                      >–</a
                    ><span class="UiQuantity__text">{{ counter }}</span
                    ><a
                      class="UiQuantity__btn btn-plus"
                      @click.prevent="
                        addCount(selectedSpec === null ? 1 : selectedSpec.Stock)
                      "
                      >＋</a
                    >
                  </div>
                  <button class="btn btn-add-cart" @click.prevent="addToCart">
                    {{ btnDescriptionGenerate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="addon-select-m">
            <div class="UiQuantity">
              <a
                class="UiQuantity__btn UiQuantity__btn--minus"
                @click.prevent="reduceCount"
                >–</a
              ><span class="UiQuantity__text">{{ counter }}</span
              ><a
                class="UiQuantity__btn UiQuantity__btn--plus"
                @click.prevent="
                  addCount(selectedSpec === null ? 1 : selectedSpec.Stock)
                "
                >＋</a
              >
            </div>
            <button class="btn btn-add-cart" @click.prevent="addToCart">
              {{ btnDescriptionGenerate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
`;
